<template>
  <div>
    <Modal :title="title" v-model="modalShow">
      <div class="req-form">
        <Form ref="reqForm" :model="reqForm" style="padding-right: 10px" :rules="reqRule">
          <Alert type="error" v-show="errorMsgShow" show-icon>{{ errorMsg }}</Alert>
          <FormItem label="卷名称">
            <Input v-model="volumeData.name" :disabled="true" style="width: 300px" />
          </FormItem>
          <FormItem label="快照" prop="snapshot_id">
            <Select v-model="reqForm.snapshot_id" transfer placeholder="请选择要还原的快照" not-fount-text="当前卷无快照">
              <Option :key="item.id" :value="item.id" v-for="item in volumeSnapshotList">{{ item.name }}</Option>
            </Select>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button type="primary" @click="submit" :loading="submitting">提交</Button>
        <Button @click="modalShow = false" style="margin-left: 8px">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { actionPrivateCloudVolume, detailPrivateCloudVolume } from '@/api/private-cloud/volume'
import { getPrivateCloudAllVolumeSnapshot } from '@/api/private-cloud/volume-snapshot'
export default {
  name: 'volume-revert-snapshot',
  data () {
    return {
      title: '更新卷状态',
      volumeData: {},
      modalShow: false,
      submitting: false,
      reqForm: {
        snapshot_id: ''
      },
      reqRule: {
        snapshot_id: [
          { required: true, message: '请选择一个新的状态', trigger: 'change' }
        ]
      },
      volumeSnapshotList: [],
      current_status: '',
      errorMsg: '',
      errorMsgShow: false
    }
  },
  methods: {
    openModal (id, status) {
      this.current_status = status
      detailPrivateCloudVolume(id).then(res => {
        this.volumeData = res.data.volume
        this.modalShow = true
      })
      this.getVolumeSnapshotList(id)
    },
    submit () {
      this.$refs['reqForm'].validate((valid) => {
        if (valid) {
          let reqData = {
            'revert': this.reqForm
          }
          this.submitting = true
          actionPrivateCloudVolume(reqData, this.volumeData.id).then(res => {
            this.modalShow = false
            this.$Notice.success({
              title: '操作成功！'
            })
            this.submitting = false
            this.$emit('callback')
          }).catch(res => {
            this.submitting = false
            if (res.request) {
              this.errorMsg = res.request.responseText
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.errorMsg = '操作失败！'
              this.$Notice.error({
                title: '操作失败！'
              })
            }
            this.errorMsgShow = true
          })
        } else {
          this.$Notice.warning({
            title: '提交失败，请检查表单！'
          })
        }
      })
    },
    getVolumeSnapshotList (volumeId) {
      getPrivateCloudAllVolumeSnapshot({ volume_id: volumeId }).then(res => {
        this.volumeSnapshotList = res.data
      }).catch(res => {
        this.$Notice.warning({
          title: '获取快照列表失败！'
        })
      })
    }
  }
}
</script>

<style scoped>
  .req-form {
    max-height: 650px;
    overflow-y: auto;
  }
  .req-form::-webkit-scrollbar {
    width: 5px;
  }
  .req-form::-webkit-scrollbar-track {
    border-radius: 5px;
    background-color: #eee;
  }
  .req-form::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #dbdbdb;
  }
</style>
